import classNames from "classnames";
import React, { useEffect, useState } from "react";

// styles
import styles from "./waffyAlert.module.scss";

export enum AlertType {
  ERROR = "error",
  SUCCESS = "success",
}

export interface AlertProps extends React.HTMLProps<HTMLDivElement> {
  type: AlertType;
  alertTiming?: number;
  showIcon?: boolean;
}

const Alert: React.FC<AlertProps> = ({
  type,
  children,
  alertTiming = 0,
  showIcon = false,
  ...props
}: AlertProps): JSX.Element => {
  const [showAlert, setShowAlert] = useState<boolean>(true);

  useEffect(() => {
    if (alertTiming) {
      setTimeout(() => {
        setShowAlert(false);
      }, alertTiming);
    }
  }, [alertTiming]);

  if (!showAlert) return <></>;

  return (
    <div className={classNames(styles["alert"], styles[`${type}`])} {...props}>
      {showIcon && type === AlertType.ERROR && (
        <img className="icon" src="/assets/images/svg/alertError.svg" />
      )}
      {showIcon && type === AlertType.SUCCESS && (
        <img className="icon" src="/assets/images/svg/alertSuccess.svg" />
      )}
      <p>{children}</p>
    </div>
  );
};

export default Alert;
